import { render } from "./CustomCategoryFolderEditItemPane.vue?vue&type=template&id=e4101812&scoped=true&ts=true"
import script from "./CustomCategoryFolderEditItemPane.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryFolderEditItemPane.vue?vue&type=script&lang=ts"

import "./CustomCategoryFolderEditItemPane.vue?vue&type=style&index=0&id=e4101812&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4101812"]])

export default __exports__